<template>
  <span v-text="text" :class="['vux-badge', {'vux-badge-single': text.length === 1}]"></span>
</template>

<script>
export default {
  props: {
    text: [String, Number]
  }
}
</script>

<style lang="less">
@import '../../styles/variable.less';
@import '../../styles/cui/widget/cui_tab/cui_tab_tabbar';
.vux-badge {
  display: inline-block;
  text-align: center;
  background: @badge-bg-color;
  color: #fff;
  font-size: 12/@w;
  height: 18/@w;
  line-height: 19/@w;
  border-radius: 8/@w;
  padding: 0 6/@w;
  background-clip: padding-box;
}
.vux-badge-single {
  padding: 0;
  width: 16/@w;
}
</style>



// WEBPACK FOOTER //
// badge.vue?68193e05